/**
 * 从 cookie 中按 name 读取取值
 * @param {string} name - cookie 名
 * @returns {string}
 */
export function getCookie(name) {
  try {
    const list = document.cookie.split(";");
    for (let i = 0; i < list.length; i++) {
      const [key, ...v] = list[i].trim().split("=");
      if (key === name) return v.join("=").trim();
    }
  } catch (e) {}
  return "";
}

/**
 * 写入 cookie（path=/，可选子域共享）
 * @param {string} name
 * @param {string} value
 * @param {number} [maxAgeSeconds] - 最大存活秒数
 * @param {string} [domain] - 如 ".beijingfundtown.com" 则 *.beijingfundtown.com 子域共享
 */
export function setCookie(name, value, maxAgeSeconds, domain) {
  try {
    let str = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/`;
    if (maxAgeSeconds != null) str += `; max-age=${maxAgeSeconds}`;
    if (domain) str += `; domain=${domain}`;
    document.cookie = str;
  } catch (e) {}
}
